export const phoneDemoData = {
  "0": {
      text: "Respond with 1 to view the demo module (SST) in Hindi, 2 to view the demo module in English.",
      responses: { 1: '1H', 2: '1E' }
  },
  "1E": {
      text: "Humans can live on Earth because the life sustaining elements of land, water and air are present. Earth has four major domains. Press # to continue.",
      responses: { '#': '2E' }
  },
  "2E": {
      text: 'The Lithosphere is the first domain. It is the solid portion of the Earth made of rocks and the thin layer of soil containing nutrients. Press # to continue.',
      responses: { '#': '3E' }
  },
  "3E": {
      text: 'We have 7 large landmasses or continents: Asia, Africa, North America, South America, Antarctica, Europe & Australia, in decreasing order of size. Press #.',
      responses: { '#': '4E' }
  },
  "4E": {
      text: 'Some continents are joined by land, while others are separated by oceans. Look at a map to see which hemispheres each continent lies in. Press #.',
      responses: { '#': '5E' }
  },
  "5E": {
      text: 'Name the only continent through which the Equator, Tropic of Cancer & Tropic of Capricorn pass. Press 1 for Africa. Press 2 for Asia. Press 3 for Australia.',
      responses: { 1: '6E', 2: '6E', 3: '6E' }
  },
  "6E": {
      text: "Africa is the correct answer. Asia lies in the Eastern Hemisphere covering 1/3 of total land area of the Earth. Australia is an island in the Southern Hemisphere. Press #.",
      responses: { '#': '7E' }
  },
  "7E": {
      text: 'The Hydrosphere is the second domain. 71% of the earth is covered with water. Of this, more than 97% is found in oceans, and is too salty to drink. Press #.',
      responses: { '#': '8E' }
  },
  "8E": {
      text: 'There are 5 interconnected oceans – Pacific Ocean, Atlantic Ocean, Indian Ocean, Southern Ocean & Arctic Ocean, in decreasing order of size. Press #.',
      responses: { '#': '9E' }
  },
  "9E": {
      text: "The three chief movements of ocean waters are waves, tides & ocean currents. Look at a map to see which continents surround each ocean. Press #.",
      responses: { '#': '10E' }
  },
  "10E": {
      text: 'The deepest part of Earth’s surface is the Mariana Trench. Where does it lie? Press 1 for Indian Ocean. Press 2 for Pacific Ocean. Press 3 for Arctic Ocean.',
      responses: { 1: '11E', 2: '11E', 3: '11E'}
  },
  "11E": {
      text: 'Pacific Ocean is the correct answer. The Indian Ocean is the only ocean named after a country, that is, India. The Arctic surrounds the North Pole. Press #.',
      responses: { '#': '12E' }
  },
  "12E": {
      text: 'The Atmosphere is the third domain. It is a blanket of air with 78% nitrogen, 21% oxygen and other gases like argon, carbon dioxide, etc. Press #.',
      responses: { '#': '13E' }    
  },
  "13E": {
    text: 'Atmosphere is divided into 5 layers. Starting from earth’s surface, they are called troposphere, stratosphere, mesosphere, thermosphere & exosphere. Press #.',
    responses: { '#': '14E' }  
  },
  "14E": {
    text: 'Density of air is maximum at the sea level and decreases as we go up, breathing problems develop. Climbers carry oxygen cylinders to help them breathe. Press #.',
    responses: { '#': '15E' }  
  },
  "15E": {
    text: 'The Biosphere is the fourth domain. It is the narrow contact zone of land, water & air. All living organisms exist here, and are linked to each other. Press #.',
    responses: { '#': '16E' }  
  },
  "16E": {
    text: 'In fact, all domains are linked to each other. Cutting of forests causes erosion of soil. Tsunamis submerge land. Industries pollute the air. Press #.',
    responses: { '#': '17E' }  
  },
  "17E": {
    text: 'Which atmospheric gas in excess leads to an increase in global temperatures? Press 1 for oxygen. Press 2 for carbon dioxide. Press 3 for nitrogen.',
    responses: { 1: '18E', 2: '18E', 3: '18E' }  
  },
  "18E": {
    text: 'Carbon dioxide is the correct answer. It causes global warming. In fact, we must limit the use of all of Earth’s resources to maintain the balance of nature. Press #.',
    responses: { '#': '19E' }  
  },
  "19E": {
      text: 'To revise, take an outline map of the world. Label all the continents and the oceans. Colour the hydrosphere in blue and the lithosphere in green. Press #',
      responses: { '#': '20E' }
  },
  "20E": {
      text: 'You have completed Major Domains of the Earth! We would love to hear from you. Press 1 if you enjoyed the lesson. Press 2 if you did not enjoy the lesson.',
      responses: { 1: '-1', 2: '-1' }
  },
  "1H": {
      text: "मनुष्य पृथ्वी पर रह सकता है क्योंकि यहां जीवित रहने के लिए आवश्यक तत्व: भूमि, जल और वायु उपलब्ध हैं। पृथ्वी के चार प्रमुख मंडल हैं। # दबाएँ. ",
      responses: { '#': '2H' }
  },
  "2H": {
      text: 'धरती का पहला प्रमुख मंडल स्थलमंडल है। यह पृथ्वी का पथरीली चट्टानों और पोषक तत्वों से भरी मिट्टी की परत से बना हुआ भाग है। विश्व में सात महाद्वीप हैं। # दबाएँ.',
      responses: { '#': '3H' }
  },
  "3H": {
      text: 'बड़े से छोटे महाद्वीप इस प्रकार हैं: एशिया, अफ्रीका, उत्तर अमेरिका, दक्षिणी अमेरिका, एंटार्कटिका, यूरोप व ऑस्ट्रेलिया। कुछ महाद्वीप आपस में जुड़े हैं। # दबाएँ.',
      responses: { '#': '4H' }
  },
  "4H": {
      text: 'अन्य महाद्वीप महासागरों के होने के कारण एक दूसरे से विभाजित हैं।  एशिया पश्चिमी गोलार्ध में स्थित है तथा यह धरती का एक-तिहाई हिस्सा घेरता है। # दबाएँ.',
      responses: { '#': '5H' }
  },
  "5H": {
      text: 'उस महाद्वीप का नाम बताएं जिसके भीतर से भूमध्य रेखा,कर्क रेखा और मकर रेखा गुजरती हैं। एशिया के लिए 1. दबाएं, अफ्रीका के लिए 2 दबाएं, ऑस्ट्रेलिया के लिए 3 दबाएं।',
      responses: { 1: '6H', 2: '6H', 3: '6H' }
  },
  "6H": {
      text: "सही उत्तर 2. अफ्रीका है।ऑस्ट्रेलिया दक्षिणी गोलार्ध में स्थित एक द्वीप है। एटलस में देखिए कि प्रत्येक महाद्वीप धरती के किस गोलार्द्ध में स्थित है। # दबाएँ.",
      responses: { '#': '7H' }
  },
  "7H": {
      text: 'अगला प्रमुख मंडल जलमंडल है। धरती का 71% हिस्सा पानी से ढका है। 97% से अधिक पानी महासागरों में है, जिसका हम उपयोग नहीं कर सकते क्योंकि यह नमकीन होता है। # दबाएँ.',
      responses: { '#': '8H' }
  },
  "8H": {
      text: 'धरती पर एक दूसरे से जुड़े 5 महासागर हैं। आकार अनुसार बड़े से छोटा: प्रशांत महासागर, अटलांटिक, हिंद, दक्षिणी, और सबसे छोटा आर्कटिक महासागर। # दबाएँ.',
      responses: { '#': '9H' }
  },
  "9H": {
      text: "लहरें, ज्वार और महासागरीय धाराएं - महासागर के जल की तीन मुख्य गतियां हैं। एटलस या नक्शे में देखिए कि प्रत्येक महासागर किन महाद्वीपों से घिरा हुआ है। # दबाएँ.",
      responses: { '#': '10H' }
  },
  "10H": {
      text: 'पृथ्वी का सबसे गहरा हिस्सा- मरियाना ट्रेंच किस महासागर में स्थित है? प्रशांत महासागर के लिए 1 दबाएं, हिंद महासागर के लिए 2 दबाएं और आर्कटिक के लिए 3 दबाएं।',
      responses: { 1: '11H', 2: '11H', 3: '11H'}
  },
  "11H": {
      text: 'सही उत्तर 1. प्रशांत महासागर है। हिंद एकमात्र महासागर है जिसका किसी देश के आधार पर नामकरण हुआ है। आर्कटिक महासागर उत्तरी ध्रुव को चारों ओर से घेरता है। # दबाएँ.',
      responses: { '#': '12H'}
  },
  "12H": {
      text: 'तीसरा मंडल वायुमंडल है। यह एक हवा की चादर की तरह है। इसमें 78% हाइड्रोजन, 21% ऑक्सीजन तथा शेष 1% आर्गन, कार्बन डाइऑक्साइड आदि गैस होती है। # दबाएँ.',
      responses: { '#': '13H' }
  },
  "13H": {
      text: 'वायुमंडल 5 परतों से बना हुआ है। इन्हें धरती की सतह से शुरू करते हुए क्षोभमंडल, समतापमंडल, मध्यमंडल, आयनमंडल तथा बहिर्मंडल कहा जाता है। # दबाएँ. ',
      responses: { '#': '14H' }    
  },
  "14H": {
    text: 'वायुमंडल का घनत्व समुद्री तल पर सबसे अधिक होता है तथा ऊपर की ओर जाने पर यह घटता जाता है। कम घनत्व के कारण सांस लेने में कठिनाई होती है। # दबाएँ.',
    responses: { '#': '15H' }  
  },
  "15H": {
    text: 'जीवमंडल जल, हवा तथा भूमि के बीच का एक सीमित भाग है। सभी जीवो का अस्तित्व यहां है,और वह एक दूसरे से जुड़े हुए हैं। सभी मंडल एक दूसरे से जुड़े हुए हैं। # दबाएँ. ',
    responses: { '#': '16H' }  
  },
  "16H": {
    text: ' वनों के कटने से मिट्टी का क्षरण होता है। सुनामी के कारण भूमि जलमग्न हो जाती है। उद्योग वायु को प्रदूषित करते हैं। भूमंडलीय तापमान का बढ़ना हानिकारक है। # दबाएँ',
    responses: { '#': '17H' }  
  },
  "17H": {
    text: 'वायुमंडल की किस गैस के अत्यधिक होने से वैश्विक तापमान बढ़ रहा है? ऑक्सीजन के लिए 1. दबाएं, कार्बन डाइऑक्साइड के लिए 2 दबाएं, नाइट्रोजन के लिए 3 दबाएं।',
    responses: { 1: '18H', 2: '18H', 3: '18H' }  
  },
  "18H": {
    text: 'सही उत्तर 2. कार्बन डाइऑक्साइड है। हमें पृथ्वी के संसाधनों का सीमित उपयोग करना है ताकि मुख्य मंडलों के बीच का प्राकृतिक संतुलन ना बिगड़े। # दबाएँ.',
    responses: { '#': '19H' }  
  },
  "19H": {
    text: 'गृहकार्य: दुनिया की रूपरेखा का नक्शा लें। सभी महाद्वीपों और महासागरों को लेबल करें। नीले रंग में जलमंडल और हरे में लिथोस्फियर को रंग दें। # दबाएँ.',
    responses: { '#': '20H' }  
  },
  "20H": {
      text: 'आपने इस पाठ को खत्म कर लिया है। यदि आपको पाठ पसंद आया तो 1. दबाएं, यदि आपको पाठ नहीं पसंद आया तो 2. दबाएं।',
      responses: { 1: '-1', 2: '-1' }
  },
  "-1": {
      text: "End of Demo"
  }
}
export const getList = (dict, lang) => {
    const list = []
    for (const [key, value] of Object.entries(dict)) {
        if (key.includes(lang)) {
            const temp = {}
            temp.sms = value.text
            temp.index = key.length === 3 ? key.substring(0, 2) : key.charAt(0)
            list.push(temp)
        }
    }
    return list
}

// export const hindi = ['प्रस्तुत कविता के कवि केदारनाथ अग्रवाल जी हैं।  इस कविता में कवि एक नीली चिड़िया के कुछ ऐसे गुणों की चर्चा करते हैं जो हमें स्वयं में भी अपनाने चाहिए। # दबाएँ.', 
// 'कविता का भावार्थ: इस कविता के पहले पद में कवि हमें यह दिखाते हैं कि एक छोटी-सी नीली, खुशमिजाज चिड़िया अपना पेट किस प्रकार भर्ती है। # दबाएँ.',
// 'यह चिड़िया कच्चे दूध भरे ज्वार के दाने खाकर संतुष्ट रहती है। संतुष्टि का अर्थ बताएं - यदि उत्तर परिपूर्णता/आनंद है तो 1 दबाएं यदि उत्तर अहंकार है तो 2 दबाएं।',
// 'सही उत्तर1 है। इस नीली चिड़िया की तरह हमें भी जीवन में कठिनाइयों के बावजूद सदा संतुष्ट रहना चाहिए। # दबाएँ.', 
// 'अगले पद में कवि हमें बताते हैं यह चिड़िया कहां रहती है। छोटी चिड़िया एक घने जंगल में रहती है। इस जंगल को कवि ने एक बूढ़ा बाबा कहा है। # दबाएँ.', 
// 'वे जंगल को यह क्यों बुलाते हैं? यदि इसलिए क्योंकि जंगल के सारी पत्ते झड़ चुके हैं तो 1 दबाएं, यदि इसलिए क्योंकि जंगल बहुत पुराना है तो 2 दबाएं।',
// 'सही उत्तर 2 है। वह छोटी-सी चिड़िया इस कठिन वातावरण में भी अपनी रसीली आवाज में गाना गाया करती है। उसके गाने से जंगल रसीले गीतों से से भर उठता है। # दबाएँ.',
// 'यह छोटी सी चिड़िया एकांत भरे घने जंगल में भी उमंग से गाती और प्रसन्न रहती है। हमें भी जीवन के हर मोड़ पर प्रसन्न हो कर आगे बढ़ना होगा। # दबाएँ.',
// 'कविता के आखिरी पद में कवि हमें बताते हैं कि यह छोटी नीली चिड़िया अपनी प्यास कैसे बुझाती है। निडर चिड़िया चालाकी से उफनती नदी के बीच से पानी पी लेती है। # दबाएँ.',
// 'इस प्रकार वह बहुत कुशलता से अपनी प्यास बुझाती है। नदी की गति बहुत तेज होती है परंतु यह छोटी चिड़िया बहुत हिम्मत से आगे बढ़ती है।  Press #.', 
// 'छोटी चिड़िया नदी से बहुत प्यार करती है। "कुशलता" का अर्थ बताएं। यदि अर्थ भयभीत होना है तो 1. दबाएं, यदि अर्थ चतुराई व होशियारी से काम लेना है तो 2. दबाएं।',
// 'सही उत्तर 2. है। इस चिड़िया की भांति हमें भी हिम्मत को कभी नहीं खोना है। धैर्य और हिम्मत के साथ जीवन की हर कठिनाई को पार किया जा सकता है। # दबाएँ.', 
// 'अंत में, इस चिड़िया के माध्यम से कवि हमें जीवन में तीन गुणों का महत्व समझाते हैं। यह तीन गुण हैं: संतुष्ट रहना, प्रसन्नता से जीना, व  हिम्मती बन्ना। # दबाएँ.',
// 'आइए कुछ पर्यायवाची शब्द सीखें। 1.पर्यावरण: वातावरण 2. चिड़िया: पक्षी, पखेरू, पंछी 3. कठिनाई: बाधा, परेशानी, जटिलता 4.जंगल: अरण्य, विपिन, वन। # दबाएँ.',
// '5. प्रसन्नता : हर्ष, उल्लास, खुशी 6. हिम्मत: शौर्य, पराक्रम, शीघ्रता। इन शब्दों को अपनी कॉपी में लिखें और इनसे नए वाक्य बनाने का प्रयास करें। # दबाएँ.',
// 'ऐसे शब्द जो संज्ञाओं की विशेषता बताते हैं, वह विशेषण कहलाते हैं। मोटे छपे विशेषणों देखिए:1 मैंने एक काले कौवे को देखा। 2 मूंछवाले दुकानदार ने दूध बेचा। # दबाएँ.',
// 'दिए गए वाक्यों में विशेषण पहचानिए: 1. एक रंगीन तोता उड़ता चला गया। 2. एक हसमुख आदमी मेरे घर आया। # दबाएँ.', 
// 'उत्तर: पहले वाक्य में रंगीन विशेषण है। दूसरे वाक्य में हंसमुख विशेषण है। अपनी पुस्तक में विशेषणओं का इस्तेमाल करके 5 नए वाक्य बनाएं। # दबाएँ.',
// 'गृह कार्य: अपने मनपसंद जानवर के बारे में कुछ पंक्तियां लिखें। उनके ऐसे गुणों के बारे में भी लिखें जिनसे आप प्रेरित होते हैं। # दबाएँ.',
// 'आपने इस पाठ को खत्म कर लिया है। यदि आपको पाठ पसंद आया तो 1. दबाएं, यदि आपको पाठ नहीं पसंद आया तो 2. दबाएं।']